/**
 * Stable identity for a candidate's liked-state and list React key. Ballotpedia-
 * only candidates have no `id` until their ballot is rebuilt, so fall back to the
 * unique URL, then name — else every id-less candidate shares one `undefined` key.
 */
export function candidateKey(candidate: {
  id?: string;
  ballotpediaUrl?: string;
  fullName?: string;
}): string {
  return candidate.id ?? candidate.ballotpediaUrl ?? candidate.fullName ?? '';
}
